import { useState } from "react"
import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material"
import type { SelectChangeEvent } from "@mui/material"
import { useOrganizations } from "../useOrganizations"
import { ExamSummarySection } from "./ExamSummarySection"
import { ExamLessonsSection } from "./ExamLessonsSection"
import { ExamEquipmentSection } from "./ExamEquipmentSection"
import { ExamDurationSection } from "./ExamDurationSection"
import { ExamTasksSection } from "./ExamTasksSection"
import { ExamSafetySection } from "./ExamSafetySection"
import { ExamFailedSection } from "./ExamFailedSection"
import { ExamFailReasonsSection } from "./ExamFailReasonsSection"
import { ExamRetakeSection } from "./ExamRetakeSection"

export function ExamPerformanceTab() {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null)
  const { organizations, error: orgError, refetch: refetchOrgs } = useOrganizations()

  const handleOrgChange = (event: SelectChangeEvent<string>) => {
    setSelectedOrgId(event.target.value || null)
  }

  return (
    <Box>
      {orgError && (
        <Alert severity="warning" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={refetchOrgs}>Retry</Button>}>
          {orgError}
        </Alert>
      )}
      <Box sx={{ mb: 3 }}>
        <FormControl size="small" sx={{ minWidth: 240 }}>
          <InputLabel shrink>Organization</InputLabel>
          <Select<string>
            value={selectedOrgId ?? ""}
            label="Organization"
            onChange={handleOrgChange}
            displayEmpty
            notched
          >
            <MenuItem value="">All organizations</MenuItem>
            {organizations.map((org) => (
              <MenuItem key={org.id} value={org.id}>
                {org.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}><ExamSummarySection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamLessonsSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamEquipmentSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamDurationSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamTasksSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamSafetySection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamFailedSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}><ExamFailReasonsSection orgId={selectedOrgId} /></Grid>
        <Grid item xs={12}>
          <ExamRetakeSection orgId={selectedOrgId} />
        </Grid>
      </Grid>
    </Box>
  )
}
